<script lang="ts">
import { DownOutlined } from "@ant-design/icons-vue";
import { ref, computed, defineComponent } from "vue";
import downImgGreen  from "@/assets/images/down-circle-green.png"
import downImg  from "@/assets/images/down-circle.png"
import store from "@/store";
export default defineComponent({
  name: "Search",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    collapsed: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    showCollapsed: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    searchText: {
      type: String,
      default: "查询",
    },
    resetText: {
      type: String,
      default: "重置",
    },
  },
  components: { DownOutlined },
  emits: ["search", "reset", "toggleFn", "update:showCollapsed"],
  setup(props, { emit }) {
    const reset = () => {
      emit("reset", "");
    };
    const search = () => {
      emit("search", "");
    };
    const toggleFn = () => {
      emit("toggleFn", "");
    };
    const themeName=computed(() => store.state.theme.themeName);
    return {
      reset,
      search,
      toggleFn,
      themeName,
      downImgGreen,
      downImg
    };
  },
});
</script>
<template>
  <a-space :size="10">
    <a-button :loading="loading" type="primary" @click="search">{{ searchText }}</a-button>
    <a-button @click="reset" class="reset">{{ resetText }}</a-button>
    <div class="biaoshi" @click.stop="toggleFn" v-if="showCollapsed">
      <!-- {{ collapsed ? "展开" : "收起" }} -->
      <img
        :src="themeName=='green'?downImgGreen:downImg"
        style="width: 14px; height: 14px"
        v-if="collapsed"
      />
      <img
        :src="themeName=='green'?downImgGreen:downImg"
        style="width: 14px; height: 14px; transform: rotate(180deg)"
        v-else
      />
      <!-- <DownOutlined v-if="collapsed" />
      <DownOutlined :rotate="180" v-else="collapsed" /> -->
    </div>
  </a-space>
</template>
<style scoped lang="less">
.biaoshi {
  color: #2f7bff;
  cursor: pointer;
}
.reset {
  border: 1px solid #d9d9d9 !important;
  background-color: #f2f5fa !important;
  &:hover {
    border: 1px solid #2f7bff !important;
    color: #2f7bff !important;
  }
}
</style>
